	// video
	var $video = $('#video-in');
	if ($video.length){
		var $videoDOM = $video[0];
		$video.closest('.js-video-promo-wrap').on('click', function(){
			$(this).toggleClass('play pause');
			if ($videoDOM.paused){
				$videoDOM.play();
				$(this).addClass('play').removeClass('pause');
			} else {
				$videoDOM.pause();
				$(this).addClass('pause').removeClass('play');
			}
		});
	}
$('.js-menu-btn').click(function() {
    $('html').toggleClass('scroll-lock');
});
$('#back-top').click(function() {
    $('body,html').animate({scrollTop: 0}, 1000);
});



// WEBPACK FOOTER //
// ./js/components/custom.js